import User from '@/models/user';

/**
 * A user's display name, from whichever of the three name fields is populated.
 *
 * The document carries `name`, `firstName` and `lastName` and different signup
 * paths fill different ones — Stripe Checkout gives a single full name, the app
 * onboarding gives first/last. Preferring one field alone leaves a visibly
 * blank Name column for whole cohorts of users.
 *
 * Returns an em dash rather than an empty string so a nameless row still reads
 * as "we don't know" instead of looking like a rendering bug.
 */
export const getUserDisplayName = (user: Partial<User>): string => {
    const joined = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
    return user.name?.trim() || joined || '—';
};
